import { useState } from "react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input, Textarea } from "@/components/ui/input"
import { RoleDropdown } from "./role-dropdown"

export function MailingListModal({ children }: { children: React.ReactNode }) {
  const [role, setRole] = useState("")
  const [open, setOpen] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault()
    setSubmitting(true)
    const form = e.currentTarget
    await fetch("https://formspree.io/f/xqeyjybg", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    })
    setSubmitting(false)
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        overlayClassName="bg-black/35 backdrop-blur-[6px]"
        className="
          top-auto bottom-0 left-0 right-0 max-w-full translate-x-0 translate-y-0
          rounded-b-none rounded-t-2xl max-h-[90svh] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]
          sm:top-[50%] sm:left-[50%] sm:right-auto sm:bottom-auto
          sm:translate-x-[-50%] sm:translate-y-[-50%]
          sm:max-w-lg sm:rounded-2xl sm:max-h-[85svh]
          border-[#e7e5e4] bg-[#fafaf9] text-[#0a0a0a] shadow-2xl
        "
      >
        <DialogHeader>
          <DialogTitle className="text-[#0a0a0a]">Get product updates</DialogTitle>
          <DialogDescription className="text-[#78716c]">
            Be the first to know when new features ship. We&apos;ll keep it relevant.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-2 pb-2">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="mailing-email" className="text-sm text-[#57534e]">
              Email <span className="text-[#F26B1D]">*</span>
            </label>
            <Input
              id="mailing-email"
              type="email"
              name="email"
              required
              placeholder="you@example.com"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="text-sm text-[#57534e]">
              Role <span className="text-[#a8a29e] text-xs">(optional)</span>
            </label>
            <RoleDropdown value={role} onChange={setRole} />
            {role === "other" && (
              <Input
                type="text"
                name="roleOther"
                placeholder="Please specify your role"
              />
            )}
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="mailing-problem" className="text-sm text-[#57534e]">
              What do you use recost for?{" "}
              <span className="text-[#a8a29e] text-xs">(optional)</span>
            </label>
            <Textarea
              id="mailing-problem"
              name="problem"
              rows={3}
              placeholder="Describe the problem you're trying to solve..."
            />
          </div>

          <label className="flex items-center gap-2.5 cursor-pointer">
            <div className="relative flex items-center justify-center">
              <input
                type="checkbox"
                name="mailingList"
                value="yes"
                className="peer h-4 w-4 appearance-none rounded border border-[#d6d3d1] bg-white checked:bg-[#F26B1D] checked:border-[#F26B1D] focus:outline-none focus:ring-1 focus:ring-[#F26B1D]/15 cursor-pointer"
              />
              <svg
                className="pointer-events-none absolute h-3 w-3 text-white opacity-0 peer-checked:opacity-100"
                viewBox="0 0 12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="2,6 5,9 10,3" />
              </svg>
            </div>
            <span className="text-sm text-[#57534e]">Sign me up for product updates</span>
          </label>

          <Button
            type="submit"
            disabled={submitting}
            className="mt-1 h-11 bg-[#F26B1D] text-white hover:bg-[#F26B1D]/90 font-medium w-full disabled:opacity-60"
          >
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}

